<template>
  <header class="header">
    <!-- Navigation -->
    <nav id="navigation" class="navbar navbar-expand-xl bg-scroll">
      <!-- Logo -->
      <!-- desktop size -->
      <a class="navbar-brand" href="/#home">
        <span><img v-if="settings.logo" :src="baseUrl + settings.logo.path" alt="logo" height="50px"></span><span>{{settings.pageName}}</span></a>
      <!-- ipad size -->
      <!-- <a class="navbar-brand d-md-none" href="#home"><img v-if="settings.logo" :src="baseUrl + settings.logo.path" alt="logo" height="50px"></a> -->
      <!-- mobile size -->
      <!-- <a class="navbar-brand d-none d-lg-block" href="#home"><img v-if="settings.logo" :src="baseUrl + settings.logo.path" alt="logo" height="50px">{{settings.pageName}}</a> -->
      <!-- Logo end -->
      <!-- Burger menu button -->
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="burger-menu">
                        <span class="burger"></span>
                    </span>
      </button>
      <!-- Burger menu button end -->
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto">

          <template v-for="item in menu">
            <li v-if="item.visible" class="nav-item">
              <a v-bind:href="item.link" v-bind:data-anchor="'#' + item.anchor" class="nav-link" v-on:click="scrollTo">{{item.menuText}}</a>
            </li>
          </template>

          <li v-if="subMenu" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Mehr</a>
            <div class="dropdown-menu" style="right:0; left:auto;" aria-labelledby="navbarDropdown">
              <template v-for="subitem in subMenu">
                <a v-if="subitem.visible" class="dropdown-item" v-bind:href="subitem.link">{{subitem.menuText}}</a>
              </template>
            </div>
          </li>

        </ul>
      </div>

    </nav>
    <!-- Navigation end -->
  </header>
</template>

<script>
  const anime = require('animejs/lib/anime');
  require('waypoints/lib/jquery.waypoints');

  export default {
    data () {
      return {

      }
    },
    mounted () {

      var route = this.$route;

      // Scrollspy and smooth scroll
      $('body').scrollspy({
        target: ".navbar",
        offset: 71
      });

      $('.navbar-brand, .navbar a, .hint').on("click", function () {
        console.log('scroll animate');
        //Toggle Class
        $(".active").removeClass("active");
        $(this).closest('li a').addClass("active");
        var theClass = $(this).attr("class");
        $('.' + theClass).parent('li a').addClass('active');
        //Animate
        $('html, body').stop().animate({
          scrollTop: $($(this).attr('data-anchor')).offset().top - 70
        }, 1000);
        $(".navbar-collapse").collapse('hide');
        $(".burger-menu").removeClass("menu-on");
        return false;
      });

      //navbar color after scroll
      $(window).on("scroll", function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 100) {
          $(".navbar").addClass("bg-scroll");
        } else {
          // disable menu bar color change for gdpr and imprint
          if(route.path !== '/gdpr' && route.path != '/imprint' && route.path != '/faq' && route.path != '/blog')
          {
            $(".navbar").removeClass("bg-scroll");
          }
        }
      });

      //Burger button
      $(".navbar-toggler").on('click', function () {
        $(".burger-menu").toggleClass("menu-on");
      });
    },
    methods: {
      scrollTo: function (event) {
        console.log(event);
        $(".active").removeClass("active");
        //event.target.closest('li a').addClass("active");
        //var theClass = event.target.attr("class");
        //$('.' + theClass).parent('li a').addClass('active');
        //Animate
        $('html, body').stop().animate({
          scrollTop: $($(event.target).attr('data-anchor')).offset().top - 70
        }, 1000);
        return false;
      }
    },
    computed:{
      menu(){
        return this.$store.getters.menu();
      },
      subMenu(){
        return this.$store.getters.subMenu();
      },
      settings(){
        return this.$store.getters.settings();
      },
      baseUrl(){
        return this.$store.getters.baseUrl();
      }
    },
    props: [],
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .navbar {
    padding-top: 30px;
    position: fixed;
    z-index: 999;
    padding-bottom: 0;
    /*background-color: #FCFCFF;
    box-shadow: 0 2px 4px 0 rgba(20, 20, 40, 0.10);*/
    height: 70px;
    width: 100%;
    -webkit-transition: .5s;
    transition: .5s;
  }

  /* header logo */

  .navbar-brand {
    color: #F7F7FC;
    letter-spacing: 1px;
    width: 70px;
    height: 70px;
    padding: 0;
    line-height: 70px;
    font-size: 24px;
    font-weight: bold;
    text-transform: uppercase;
    font-family: 'Roboto Slab', serif;
  }

  .navbar-brand:hover {
    color: #F7F7FC;
  }

  .navbar-brand img {
    margin: 7px 30px 10px 15px;
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }

  /* navbar link */

  .nav-link {
    display: inline-block;
    color: #F7F7FC;
    height: 70px;
    padding: 28px;
    font-size: 11px;
    font-weight: bold;
    letter-spacing: 2px;
    text-transform: uppercase;
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }

  .navbar ul li .active,
  .nav-link:hover {
    color: #F7F7FC;
    background-color: rgba(240, 240, 240, .1);
  }

  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 20px;
    padding-left: 20px;
  }

  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 15px;
    padding-left: 15px;
  }


  /* navbar after scroll */

  .bg-scroll {
    padding-top: 0;
    background-color: rgba(250, 250, 255, 1);
    -webkit-box-shadow: 0 2px 4px 0 rgba(20, 20, 40, 0.10);
    box-shadow: 0 2px 4px 0 rgba(20, 20, 40, 0.10);
  }

  .bg-scroll .navbar-brand,
  .bg-scroll .nav-link {
    color: hsla(263.72, 15.83%, 31.06%, 1);
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }

  .bg-scroll ul li .active,
  .bg-scroll .nav-link:hover {
    color: hsla(263.72, 15.83%, 31.06%, 1);
    background-color: rgba(25, 45, 55, .02);
  }

  .bg-scroll .contact-us {
    color: #F7F7FC;
  }

  /* dropdown */

  .dropdown-menu {
    background-color: rgba(250, 250, 255, 1);
    -webkit-box-shadow: 0 2px 4px 0 rgba(20, 20, 40, 0.10);
    box-shadow: 0 2px 4px 0 rgba(20, 20, 40, 0.10);
    border-radius: 0;
    border: 0;
    top: 68px;
    left: 0;
    padding: 0;
  }

  .dropdown .dropdown-menu {
    display: block;
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }

  .dropdown:hover .dropdown-menu {
    max-height: 200px;
    display: block;
    opacity: 1;
  }

  .dropdown-menu .dropdown-item {
    color: rgba(25, 45, 55, 1);
    padding: 15px;
    letter-spacing: 2px;
    font-size: 11px;
    font-weight: bold;
    text-transform: uppercase;
  }

  /******************************

  10. Burger button

  ******************************/

  .navbar-toggler {
    right: 300px;
    height: 50px;
    width: 50px;
    position: relative;
    right: 0;
    top: 0;
    padding: 0;
  }

  .navbar-toggler:active,
  .navbar-toggler:focus {
    outline: inherit;
  }

  .burger {
    position: absolute;
    background-color: rgba(25, 45, 55, 1);
    width: 30px;
    height: 4px;
    right: 10px;
    border-radius: 2px;
    margin-top: -3px;
    opacity: 1;
  }

  .burger::before {
    position: absolute;
    background-color: rgba(25, 45, 55, 1);
    width: 30px;
    height: 4px;
    top: 10px;
    border-radius: 2px;
    content: "";
    display: block;
  }

  .burger::after {
    position: absolute;
    background-color: rgba(25, 45, 55, 1);
    width: 30px;
    height: 4px;
    bottom: 10px;
    border-radius: 2px;
    content: "";
    display: block;
  }

  .burger::after,
  .burger::before,
  .burger {
    transition: all .3s ease-in-out;
    -webkit-transition: all .3s ease-in-out;
  }

  .burger-menu.menu-on .burger::after {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    bottom: 0px;
  }

  .burger-menu.menu-on .burger::before {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    top: 0px;
  }

  .burger-menu.menu-on .burger {
    background: transparent;
  }

  @media (max-width: 380px){
    .navbar-brand img {
      margin: 0px 5px 0px 0px;
    }
  }

  @media (max-width: 1200px) {
    .navbar {
      padding-top: 0;
      padding-bottom: 0;
      height: auto;
      background-color: #FCFCFF;
      -webkit-box-shadow: 0 2px 4px 0 rgba(20, 20, 40, 0.10);
      box-shadow: 0 2px 4px 0 rgba(20, 20, 40, 0.10);
      color: rgba(25, 45, 55, 1);
    }

    .nav-link:hover,
    .nav-link,
    .navbar-brand:hover,
    .navbar-brand,
    .navbar ul li .active,
    .nav-link:hover {
      color: hsla(263.72, 15.83%, 31.06%, 1);
    }

    .nav-link {
      height: 30px;
      padding-top: 15px;
      width: 100%;
      border-radius: 5px;
    }

    .navbar-nav {
      height: auto;
    }

    .dropdown .dropdown-menu {
      margin-top: 10px;
      padding-left: 15px;
      display: none;
      background-color: transparent;
      -webkit-box-shadow: none;
      box-shadow: none;
    }

    .contact-us {
      margin: 30px 0 0 20px;
      color: #F7F7FC;
    }

    .dropdown-item {
      border-radius: 5px;
    }

    .navbar-collapse {
      padding: 30px 0;
    }

    .dropdown-menu .dropdown-item:hover {
      background-color: rgba(240, 240, 240, .1);

    }
  }

  @media (min-width: 1250px) {

  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue